module.exports = __webpack_public_path__ + "static/house--background@3x.09df065b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/house--background@3x.png
// module id = 1285
// module chunks = 35783957827783